import React, { useState, useEffect, useRef } from 'react';
import { REBRAND_COLOR } from '@latitude/core/utils/constants';
import { debounce as _debounce } from 'lodash';
import { Typography } from '@latitude/typography';
import Button from '@latitude/button-rebrand';
import { Filter } from '@/components/FilterRebrand/FilterRebrand';
import parse from 'html-react-parser';
import {
  StyledImageContainer,
  StyledBgImage,
  StyledCardArtImage,
  StyledCardFilterContainer,
  StyledContentContainer,
  StyledTextContainer,
  StyledCard,
  StyledStatsRow,
  StyledStatBox,
  StyledDescriptionList,
  StyledFilterContainer,
  StyledActions,
  StyledSubHeading,
  StyledHeader,
  Wrapper
} from './CardFilterListRebrand.styled';

const COMPONENT_ID = 'card-filter-list-rebrand';

const CardFilterListRebrand = ({
  id,
  heading,
  cards,
  filterOptions,
  trackingId
}) => {
  const componentIdentifier = trackingId
    ? `${trackingId}-${COMPONENT_ID}`
    : `${COMPONENT_ID}`;
  const [selectedFilter, setSelectedFilter] = useState('all');
  const isBalanceTransfer = selectedFilter === 'balance-transfer';

const appendPromoCode = (cta) => {
  const promoCode = isBalanceTransfer
  ? cta?.btPromoCode
  : cta?.promocode;
  console.log("promo", promoCode, selectedFilter )
  return promoCode ? `${cta?.url}&promo_code=${promoCode}` : `${cta?.url}`;
}
  
  const cardHeaderRef = useRef({});
  const cardStatsRef = useRef({});

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const hashValue = window.location.hash.slice(1);

    if (hashValue) {
      setSelectedFilter(hashValue.toLowerCase());
    }
  }, []);

  useEffect(() => {
  if (typeof window === 'undefined') return;

  const section = document.getElementById('credit-card-filter-list');
  if (!section || selectedFilter === 'all') return;

  const offsetTop = 50;

  const scrollToSection = () => {
    const elementPosition =
      section.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: elementPosition - offsetTop,
      behavior: 'smooth',
    });
  };

  const timeout = setTimeout(scrollToSection, 300);

  return () => clearTimeout(timeout);
}, [selectedFilter]);

  const filteredCards = React.useMemo(() => {
  //   if (!selectedFilter || selectedFilter === 'all') return cards;

  //   const normalizedFilter = selectedFilter.toLowerCase();

  //   return cards.filter(card =>
  //     card.category?.some(cat => cat.toLowerCase() === normalizedFilter)
  //   );
  // }, [cards, selectedFilter]);
  
  let filtered = [...cards];
    if (selectedFilter && selectedFilter !== 'all') {
      const normalizedFilter = selectedFilter.toLowerCase();
      filtered = filtered.filter(card =>
        card.category?.some(cat => cat.toLowerCase() === normalizedFilter)
      );
    }

    // Sort by order for the selected filter
    filtered.sort((a, b) => {
      const aOrder = a.order?.[selectedFilter] ?? Infinity;
      const bOrder = b.order?.[selectedFilter] ?? Infinity;
      return aOrder - bOrder;
    });

    return filtered;
  }, [cards, selectedFilter]);

  const groupCardsByRow = () => {
    const cards = Object.values(cardHeaderRef.current).filter(Boolean);
    const rows = {};

    cards.forEach(card => {
      const top = card.offsetTop; // vertical position
      if (!rows[top]) rows[top] = [];
      rows[top].push(card);
    });

    return Object.values(rows); // returns an array of arrays, each sub-array is a row
  };
  const groupCardsByRowStat = () => {
    const cards = Object.values(cardStatsRef.current).filter(Boolean);
    const rows = {};

    cards.forEach(card => {
      const top = card.offsetTop; // vertical position
      if (!rows[top]) rows[top] = [];
      rows[top].push(card);
    });

    return Object.values(rows); // returns an array of arrays, each sub-array is a row
  };
  const equalizeCardHeaderHeight = () => {
    if (window.innerWidth < 768) {
      // Reset on mobile
      Object.values(cardHeaderRef.current).forEach(el => {
        if (el) el.style.minHeight = 'auto';
      });
      return;
    }

    const rows = groupCardsByRow();
    const rowsStat = groupCardsByRowStat();

    rows.forEach(row => {
      let maxHeight = 0;

      // find max height in the row
      row.forEach(el => {
        if (el && el.offsetHeight > maxHeight) {
          maxHeight = el.offsetHeight;
          console.log("el offset",el.offsetHeight);
        }
        console.log("max height",maxHeight);
      });

      // apply max height to all cards in this row
      row.forEach(el => {
        if (el) el.style.minHeight = `${maxHeight}px`;
      });
    });

     rowsStat.forEach(row => {
      let maxHeight = 0;

      // find max height in the row
      row.forEach(el => {
        if (el && el.offsetHeight > maxHeight) {
          maxHeight = el.offsetHeight;
          console.log("el offset",el.offsetHeight);
        }
        console.log("max height",maxHeight);
      });

      // apply max height to all cards in this row
      row.forEach(el => {
        if (el) el.style.minHeight = `${maxHeight}px`;
      });
    });
  };

  
  const handleWindowResize = () => {
    equalizeCardHeaderHeight();
  };

  const debouncedHandleResize = _debounce(handleWindowResize, 100);

  useEffect(() => {
    equalizeCardHeaderHeight();
    window.addEventListener('resize', debouncedHandleResize);
    return () => window.removeEventListener('resize', debouncedHandleResize);
  }, [cardHeaderRef, filteredCards]);

  useEffect(() => {
    debouncedHandleResize();
  }, []);
  return (
    <Wrapper id={id} className={componentIdentifier}>
    <StyledCardFilterContainer>
      <Typography.H4>{heading}</Typography.H4>
      {filterOptions && (
        <StyledFilterContainer
          className={`${componentIdentifier}-filter-container`}
        >
          <Filter
            options={filterOptions}
            value={selectedFilter}
            onChange={setSelectedFilter}
            inactiveColor={REBRAND_COLOR.WHITE}
            location={heading}
          />
        </StyledFilterContainer>
      )}
      <StyledContentContainer
        className={`${componentIdentifier}-content-container`}
      >
        {filteredCards.map((card, index) => (
          <StyledCard
            className={`${componentIdentifier}-card-container`}
            key={index}
          >
            <StyledImageContainer
              className={`${componentIdentifier}-img-container`}
            >
              <StyledBgImage
                src={card.bgImage.url}
                alt={card.bgImage.name}
                className={`${componentIdentifier}-bg-image`}
                productid={card?.productid}
              />
              <StyledCardArtImage
                src={card.cardArt.url}
                alt={card.bgImage.name}
                className={`${componentIdentifier}-card-art-image`}
                productid={card?.productid}
              />
            </StyledImageContainer>
            <StyledTextContainer
              className={`${componentIdentifier}-text-container`}
            >
              <StyledHeader
                ref={el => (cardHeaderRef.current[card.title] = el)}
              >
                <Typography.SH1>{card.title}</Typography.SH1>
              </StyledHeader>

              {card?.fee && card?.rate && (
                <StyledStatsRow
                  className={`${componentIdentifier}-row-container`}
                  ref={el => (cardStatsRef.current[card.title] = el)}
                >
                  {card?.fee && (
                    <StyledStatBox
                      className={`${componentIdentifier}-stat-container-fee`}
                    >
                      <Typography.N4 color={REBRAND_COLOR.MID_BLUE}>
                        {card.fee.value}
                      </Typography.N4>
                      <Typography.Caption color={REBRAND_COLOR.INDIGO}>
                        {card.fee.label}
                      </Typography.Caption>
                    </StyledStatBox>
                  )}

                  {card?.rate && (
                    <StyledStatBox
                      className={`${componentIdentifier}-stat-container-rate`}
                    >
                      <Typography.N4 color={REBRAND_COLOR.MID_BLUE}>
                        {card.rate.value}
                      </Typography.N4>
                      <Typography.Caption color={REBRAND_COLOR.INDIGO}>
                        {card.rate.label}
                      </Typography.Caption>
                    </StyledStatBox>
                  )}
                </StyledStatsRow>
              )}

              {card?.subheading && (
                <StyledSubHeading
                  className={`${componentIdentifier}-sub-heading`}
                  ref={el => (cardStatsRef.current[card.title] = el)}
                >
                  <Typography.SH4>{card.subheading}</Typography.SH4>
                </StyledSubHeading>
              )}

              <StyledDescriptionList
                className={`${componentIdentifier}-description-list`}
              >
                {card.description.map((item, i) => (
                  <Typography.Body
                    as="li"
                    key={i}
                    color={REBRAND_COLOR.INDIGO}
                  >
                    {parse(item)}
                  </Typography.Body>
                ))}
              </StyledDescriptionList>

              <StyledActions className={`${componentIdentifier}-cta-wrapper`}>
                {card.ctas?.[0] && (
                  <Button
                    className={`${componentIdentifier}-primary-cta`}
                    variant={card.ctas?.[0]?.variant}
                    size={card.ctas?.[0]?.size}
                    ctaText={card.ctas?.[0]?.text}
                    ctaUrl={appendPromoCode(card.ctas?.[0])}
                    trackEventData={{
                      category: 'text-link',
                      location: `branded-card-filter-primary-${card.title}`,
                      label: card.ctas?.[0]?.text
                    }}
                    trackId={COMPONENT_ID}
                  />
                )}
                {card.ctas?.[1] && (
                  <Button
                    className={`${componentIdentifier}-secondary-cta`}
                    variant={card.ctas?.[1]?.variant}
                    size={card.ctas?.[1]?.size}
                    ctaText={card.ctas?.[1]?.text}
                    ctaUrl={card.ctas?.[1]?.url}
                    trackEventData={{
                      category: 'text-link',
                      location: `branded-card-filter-secondary-${card.title}`,
                      label: card.ctas?.[1]?.text
                    }}
                    trackId={COMPONENT_ID}
                  />
                )}
              </StyledActions>
            </StyledTextContainer>
          </StyledCard>
        ))}
      </StyledContentContainer>
    </StyledCardFilterContainer>
    </Wrapper>
  );
};

export default CardFilterListRebrand;
